<template>
  <v-data-table :items="items" hide-actions>
    <template v-slot:headers>
      <tr class="headerRow grey lighten-3">
        <th>配信地点グループ名</th>
      </tr>
    </template>
    <template v-slot:items="{ item }">
      <tr
        @click="$emit('input', item)"
        :class="{ 'blue lighten-2 white--text': isSelected(item) }"
        class="itemRow"
      >
        <td>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" v-text="icon(item)" :class="iconStyles(item)" />
            </template>
            <span v-text="warningMessage(item)" />
          </v-tooltip>
          <span>{{ locationGroupName(item) }}</span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'CampaignModalPageCreativeDeliveryLocationGroupTable',
  props: {
    value: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.check()
  },
  methods: {
    isSelected(item) {
      return this.value && this.value.locationGroupId === item.locationGroupId
    },
    icon(item) {
      if (item.hasWarning) {
        return 'warning'
      } else {
        return ''
      }
    },
    iconStyles(item) {
      return [
        css`
          width: 30px;
        `,
        {
          'yellow--text text--darken-2': item.hasWarning,
        },
      ]
    },
    locationGroupName(item) {
      const locationGroup = this.form.campaign.menuSetting.findLocationGroup(
        item.locationGroupId,
      )
      return locationGroup == null ? '' : locationGroup.name
    },
    warningMessage(item) {
      if (item.noCreativesWarning) {
        return 'クリエイティブが設定されていません。'
      } else if (item.hasInactiveCreatives) {
        return '無効なクリエイティブが設定されています。'
      } else if (item.hasExpiredCreatives) {
        return '有効期限切れのクリエイティブが設定されています。'
      } else if (item.hasRejectedCreatives) {
        return '審査落ちのクリエイティブが設定されています。'
      } else {
        return ''
      }
    },
    /**
     * 各配信地点グループに紐付いたクリエイティブに問題がないか確認する。
     */
    check() {
      this.items.forEach(item => item.fetchCreatives())
    },
  },
}
</script>

<style scoped lang="scss">
.headerRow {
  height: 24px;

  th {
    padding: 0 8px !important;
    text-align: left;
  }
}

.itemRow {
  cursor: pointer;

  td {
    padding: 0 !important;
  }
}
</style>
